import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MedicalDocumentsComponent } from '@lib/medical-documents';

@Component({
  selector: 'members-documents',
  standalone: true,
  templateUrl: './member-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MedicalDocumentsComponent],
})
export class MemberDocumentsComponent {}
